import React from 'react'
import { Box } from '@mui/system'
import stylesDQ from './stylesDQ'
import { Typography } from '@mui/material'
import { FaAngleRight } from 'react-icons/fa'
import { Services } from '../../../services'

export default function DetalhesQuadra({ pedido }) {
  const empresa = pedido.empresa
  const quadra = pedido.quadra

  return (
    <Box
      sx={{
        ...stylesDQ.containerDetailsQdr,
        backgroundImage: `url(${quadra.urlFoto + quadra.foto})`,
      }}
      onClick={() => Services.SearchCountry(quadra.endereco, empresa.username, empresa.nome)}
    >
      <Box sx={stylesDQ.content}>
        <Typography sx={stylesDQ.titleQuadra}>{quadra.descricao}</Typography>
        <Typography sx={stylesDQ.titleEmpresa}>{empresa.nome}</Typography>
        <Typography sx={stylesDQ.labelQuadra}>{quadra.endereco}</Typography>
      </Box>
      <Box sx={stylesDQ.containerIcon}>
        <FaAngleRight size={25} color='#ff7043' />
      </Box>
    </Box>
  )
}
